<template>
  <div class="wineItemComponentForm">
    <div
      ref="chartdiv"
      style="height: 500px; width: 100%; padding: 0px; margin: 0px"
    ></div>
  </div>
</template>

<script>
import { readJSON } from "../helpers/Functions";

import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";

export default {
  props: ["item", "ucitan_grafik", "naslov"],
  name: "WineItem",
  components: {},
  data: () => ({
    // graphic_data:[],
    root: undefined,
    naslov_glob: "",
  }),
  computed: {},
  watch: {
    item: function (val) {
      if (this.ucitan_grafik) {
        // this.graphic_data = val;
        this.ucitajGrafik();
      }
    },
    ucitan_grafik: function (val) {
      // this.graphic_data = this.item;
      // this.ucitajGrafik();
    },
    naslov: function (val) {
      

      this.naslov_glob = val;
    },
  },
  methods: {
    ucitajGrafik: function () {
      

      let root; // = am5.Root.new(this.$refs.chartdiv);

      if (this.root !== undefined) {
        root = this.root;
        root.container.children.clear();
      } else {
        root = am5.Root.new(this.$refs.chartdiv);

        this.root = root;
      }

      root.setThemes([am5themes_Animated.new(root)]);

      // Create chart
      // https://www.amcharts.com/docs/v5/charts/xy-chart/
      var chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: true,
          panY: true,
          wheelX: "panX",
          wheelY: "zoomX",
          pinchZoomX: true,
        })
      );

      // chart.get("colors").set("step", 2);

      // Add cursor
      // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
      var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
      cursor.lineY.set("visible", false);

      // Create axes
      // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/

      var xRenderer = am5xy.AxisRendererX.new(root, {});
      xRenderer.grid.template.set("location", 0.5);
      xRenderer.labels.template.setAll({
        location: 0.5,
        multiLocation: 0.5,
      });

      var xAxis = chart.xAxes.push(
        am5xy.DateAxis.new(root, {
          maxDeviation: 0.3,
          baseInterval: {
            timeUnit: "hour",
            count: 1,
          },
          renderer: xRenderer,
          // tooltip: am5.Tooltip.new(root, {

          // }),
        })
      );

      // xAxis.tooltipDateFormat = "yyyy-MM-dd";
      xAxis.get("dateFormats")["day"] = "dd.MM.yyyy";

      // xAxis.periodChangeDateFormats.setKey("day", "dd.MM.yyyy");

      var yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          // maxDeviation: 0.3,
          renderer: am5xy.AxisRendererY.new(root, {}),
        })
      );

      // Add series
      // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
      var series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: "Temeratura (°C)",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "temperatura",
          valueXField: "date",
          tooltip: am5.Tooltip.new(root, {
            labelText: "Vreme: {valueX}\nTemperatura: {valueY} °C",
            pointerOrientation: "horizontal",
          }),
          stroke: am5.color("#845EC2"),
          fill: am5.color("#845EC2"),
        })
      );

      series.strokes.template.set("strokeWidth", 2);

      series.get("tooltip").get("background").set("fillOpacity", 0.5);

      var series2 = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: "Šećer (°Oe)",
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: "secer",
          valueXField: "date",
          tooltip: am5.Tooltip.new(root, {
            labelText: "Vreme: {valueX}\nŠećer: {secer} °Oe\nOpis: {opis}",
            pointerOrientation: "horizontal",
          }),
        })
      );
      series2.strokes.template.setAll({
        strokeDasharray: [2, 2],
        strokeWidth: 2,
      });

      // Set date fields
      // https://www.amcharts.com/docs/v5/concepts/data/#Parsing_dates
      root.dateFormatter.setAll({
        dateFormat: "dd.MM.yyyy HH:mm",
        dateFields: ["valueX"],
      });

      var data = this.item;

      series.data.setAll(data);
      series2.data.setAll(data);

      series.bullets.push(function () {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 5,
            fill: series.get("fill"),
          }),
        });
      });

      series2.bullets.push(function () {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 5,
            fill: series2.get("fill"),
          }),
        });
      });

      // Make stuff animate on load
      // https://www.amcharts.com/docs/v5/concepts/animations/
      series.appear(1000);
      series2.appear(1000);

      // series.set("fill", am5.color(0xff0000)); // set Series color to red
      // series2.set("fill", am5.color("#00ff00")); // set Series color to green

      var legend = chart.children.push(
        am5.Legend.new(root, {
          //         fillField: "color",
          // strokeField: "color",
          centerX: am5.p50,
          x: am5.p50,
        })
      );

      // Make series change state when legend item is hovered
      legend.itemContainers.template.states.create("hover", {});

      legend.itemContainers.template.events.on("pointerover", function (e) {
        e.target.dataItem.dataContext.hover();
      });
      legend.itemContainers.template.events.on("pointerout", function (e) {
        e.target.dataItem.dataContext.unhover();
      });

      legend.data.setAll(chart.series.values);

      chart.appear(1000, 100);
    },
  },
  mounted() {},
};
</script>
    
<style lang="scss" scoped>
// .wineItemComponentForm {
//   max-width: 430px;
// }
.Description textarea {
  height: 40px;
}
</style>
